"use client";

import { useState } from "react";
import { triggerDevDataFetchError } from "../dev-panel-actions";

function Boom(): null {
  throw new Error("Dev panel test: simulated render crash");
}

/** Fires the same paths as `react_render_crash` and `data_fetch_failed`, to verify RUM/CloudWatch wiring. */
export function ErrorTestingTab() {
  const [crash, setCrash] = useState(false);

  return (
    <div className="space-y-3 text-xs">
      <div>
        <button
          type="button"
          onClick={() => setCrash(true)}
          className="w-full rounded-sm bg-red-600 px-2 py-1.5 font-mono text-white hover:bg-red-700"
        >
          Trigger render crash
        </button>
        <p className="mt-1 text-neutral-500">RUM &middot; react_render_crash</p>
      </div>
      <div>
        <button
          type="button"
          onClick={() => {
            void triggerDevDataFetchError();
          }}
          className="w-full rounded-sm bg-orange-600 px-2 py-1.5 font-mono text-white hover:bg-orange-700"
        >
          Trigger data fetch failure
        </button>
        <p className="mt-1 text-neutral-500">CloudWatch &middot; data_fetch_failed</p>
      </div>
      {crash && <Boom />}
    </div>
  );
}
